<template>
  <v-list-item
    v-if="!isHidden"
    :to="{ name: to }"
    :link="!!to"
    :class="{ 'pl-9': isSubmenu }"
    class="mb-1"
    exact
    exact-path>
    <v-list-item-icon class="mr-2">
      <v-icon color="white">
        {{ icon }}
      </v-icon>
    </v-list-item-icon>
    <v-list-item-title class="white--text">
      {{ title }}
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListMenu',
  props: {
    title: {
      type: String,
      required: true
    },
    to: {
      type: [Object, String],
      default: undefined
    },
    icon: {
      type: String,
      default: undefined
    },
    iconPrepend: {
      type: Boolean,
      default: false
    },
    isSubmenu: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userData () {
      return this.$store.getters['User/user']
    },
    isHidden () {
      const hiddenPages = ['รายงาน', 'แดชบอร์ด']
      return this.userData.role === 'ADMIN' && hiddenPages.includes(this.title)
    }
  }
}
</script>
